import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneEmailCredentialPayload } from '@app-store/slices/emailCredential/oneEmailCredential'

interface TaskAction extends Action {
    payload: IOneEmailCredentialPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.emailCredential.oneEmail

function* getOneEmailTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/notifications/email-credentials/one/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getOneEmail(): any {
    yield takeLatest<TaskAction>(onRequest, getOneEmailTask)
}

export default getOneEmail
